/**
 * Blog index Product type + Brand filtering.
 *
 * No token, no GraphQL, no network requests: Liquid renders every article card
 * (capped at 50 per render by Shopify) into a hidden "pool". When a filter is
 * active we hide the normal paginated grid + pager and show the matching pool
 * cards. When no filter is active, the native paginated view is untouched.
 *
 * Visual parity with the collection (New Arrival) facets is achieved by reusing
 * the collection-filters__* / sidebar__* / active-filter-group markup + CSS.
 * Filters are multi-select per group, matching the collection checkboxes.
 *
 * NOTE: Shopify renders a maximum of 50 articles in a single pass. Once this
 * blog exceeds 50 posts the hidden pool is incomplete and filtering would need
 * the multi-page fetch (or Storefront API) approach instead.
 */
(function () {
  var root = document.querySelector('[data-blog-filters]');
  if (!root) return;

  var section = root.closest('.blog-template') || document;
  var paginatedGrid = section.querySelector('[data-paginated-grid]');
  var pager = section.querySelector('[data-blog-pager]');
  var pool = section.querySelector('[data-filter-pool]');
  var empty = section.querySelector('[data-filter-empty]');
  var activeBar = section.querySelector('[data-active-filters]');

  var poolItems = pool
    ? Array.prototype.slice.call(pool.querySelectorAll('[data-blog-post-item]'))
    : [];

  // selected = { product_type: [values], brand: [values] }
  var selected = {};

  function groupKeys() {
    return Array.prototype.map.call(
      root.querySelectorAll('[data-filter-group]'),
      function (el) { return el.getAttribute('data-filter-group'); }
    );
  }

  function labelFor(group, value) {
    var link = root.querySelector(
      '[data-filter-group="' + group + '"] [data-filter-value="' + value + '"]'
    );
    return link ? link.getAttribute('data-filter-label') : value;
  }

  function readURL() {
    var params = new URLSearchParams(window.location.search);
    groupKeys().forEach(function (group) {
      var raw = params.get(group);
      selected[group] = raw ? raw.split(',').filter(Boolean) : [];
    });
  }

  function writeURL() {
    var params = new URLSearchParams(window.location.search);
    Object.keys(selected).forEach(function (group) {
      if (selected[group] && selected[group].length) {
        params.set(group, selected[group].join(','));
      } else {
        params.delete(group);
      }
    });
    var qs = params.toString();
    window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
  }

  function isFiltering() {
    return Object.keys(selected).some(function (g) {
      return selected[g] && selected[g].length;
    });
  }

  function toggleValue(group, value) {
    if (!selected[group]) selected[group] = [];
    var i = selected[group].indexOf(value);
    if (i === -1) selected[group].push(value);
    else selected[group].splice(i, 1);
  }

  // Groups render collapsed; this opens/closes one.
  function setGroupOpen(groupEl, open) {
    var toggle = groupEl.querySelector('[data-filter-toggle]');
    var list = groupEl.querySelector('[data-filter-group-list]');
    if (toggle) {
      toggle.setAttribute('data-open', open ? 'true' : 'false');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (list) list.hidden = !open;
  }

  // Landing on a filtered URL should show which values are ticked.
  function openSelectedGroups() {
    Array.prototype.forEach.call(
      root.querySelectorAll('[data-filter-group]'),
      function (groupEl) {
        var group = groupEl.getAttribute('data-filter-group');
        if ((selected[group] || []).length) setGroupOpen(groupEl, true);
      }
    );
  }

  function syncActiveLinks() {
    var links = root.querySelectorAll('[data-filter-value]');
    Array.prototype.forEach.call(links, function (link) {
      var group = link.closest('[data-filter-group]').getAttribute('data-filter-group');
      var on = (selected[group] || []).indexOf(link.getAttribute('data-filter-value')) !== -1;
      link.classList.toggle('collection-filters__filter-link--active', on);
      link.classList.toggle('sidebar__tag-link--active', on);
      link.closest('li').classList.toggle('sidebar__block-link--active', on);
    });
  }

  function renderChips() {
    if (!activeBar) return;
    activeBar.innerHTML = '';
    if (!isFiltering()) {
      activeBar.hidden = true;
      return;
    }
    activeBar.hidden = false;
    Object.keys(selected).forEach(function (group) {
      (selected[group] || []).forEach(function (value) {
        var li = document.createElement('li');
        li.className = 'active-filter-group__item-wrapper';
        var a = document.createElement('a');
        a.className = 'active-filter-group__item';
        a.href = '#';
        a.setAttribute('data-remove-group', group);
        a.setAttribute('data-remove-value', value);
        var span = document.createElement('span');
        span.className = 'active-filter-text';
        span.textContent = labelFor(group, value);
        a.appendChild(span);
        li.appendChild(a);
        activeBar.appendChild(li);
      });
    });
    var clearLi = document.createElement('li');
    clearLi.className = 'active-filter-group--remove-all';
    var clearA = document.createElement('a');
    clearA.className = 'active-filter-group--remove-all-link';
    clearA.href = '#';
    clearA.setAttribute('data-filter-clear', '');
    clearA.textContent = 'Clear all';
    clearLi.appendChild(clearA);
    activeBar.appendChild(clearLi);
  }

  function apply() {
    syncActiveLinks();
    renderChips();

    if (!isFiltering()) {
      if (paginatedGrid) paginatedGrid.hidden = false;
      if (pager) pager.hidden = false;
      if (pool) pool.hidden = true;
      if (empty) empty.hidden = true;
      return;
    }

    if (paginatedGrid) paginatedGrid.hidden = true;
    if (pager) pager.hidden = true;
    if (pool) pool.hidden = false;

    var matches = 0;
    poolItems.forEach(function (item) {
      var ok = Object.keys(selected).every(function (group) {
        var vals = selected[group] || [];
        if (!vals.length) return true;
        var attr = 'data-' + group.replace(/_/g, '-');
        // Cards can carry several values (collab brands / multi product types);
        // match the group if ANY selected value is present on the card.
        var itemVals = (item.getAttribute(attr) || '').split(' ').filter(Boolean);
        return vals.some(function (v) { return itemVals.indexOf(v) !== -1; });
      });
      item.hidden = !ok;
      if (ok) matches++;
    });

    if (empty) empty.hidden = matches > 0;
  }

  // Filter value clicks (the checkboxes in the sidebar).
  root.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-filter-toggle]');
    if (toggle) {
      e.preventDefault();
      var openNow = toggle.getAttribute('data-open') !== 'false';
      setGroupOpen(toggle.closest('[data-filter-group]'), !openNow);
      return;
    }

    var link = e.target.closest('[data-filter-value]');
    if (!link) return;
    e.preventDefault();
    var group = link.closest('[data-filter-group]').getAttribute('data-filter-group');
    toggleValue(group, link.getAttribute('data-filter-value'));
    writeURL();
    apply();
  });

  // Chip removal + clear all (in the active-filters bar).
  if (activeBar) {
    activeBar.addEventListener('click', function (e) {
      var clear = e.target.closest('[data-filter-clear]');
      if (clear) {
        e.preventDefault();
        Object.keys(selected).forEach(function (g) { selected[g] = []; });
        writeURL();
        apply();
        return;
      }
      var chip = e.target.closest('[data-remove-group]');
      if (chip) {
        e.preventDefault();
        toggleValue(chip.getAttribute('data-remove-group'), chip.getAttribute('data-remove-value'));
        writeURL();
        apply();
      }
    });
  }

  readURL();
  openSelectedGroups();
  apply();
})();
